var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:{ 'active': _vm.isActive },attrs:{"role":"presentation"}},[_c('tab-button',{attrs:{"href":_vm.href}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }